import React from 'react';
import PropTypes from 'prop-types';
import './PageLayout.scss';
import Header from '../Header';

export const PageLayout = (props) => (
  <div className='page-layout'>
    <Header store={props.store} />
    {React.Children.map(props.children, (child, index) => {
      if (child) {
        return React.cloneElement(child, {
          parentProps: props,
        });
      }
    })
    }
  </div>
);

PageLayout.propTypes = {
  children: PropTypes.node,
  store: PropTypes.object,
};

export default PageLayout;



// WEBPACK FOOTER //
// ./src/routes/officehours/layouts/PageLayout/PageLayout.js